import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl,FormGroup, Validators,FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';
import { SharedService } from '../service/shared.service';
declare var $: any;
// import { AuthService, GoogleLoginProvider, SocialUser } from 'angularx-social-login';
import { GoogleLoginProvider, SocialAuthService, SocialUser, FacebookLoginProvider } from '@abacritt/angularx-social-login';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit{
  @Input() fromButtonLogin: any;
  @Output() onClose = new EventEmitter<string>();
  isLoginModal : any =false
  submit = false;
  isSubmitError: any = false;
  REDIRECT_URL : any = environment.API_URL + "auth/seller-social-auth-post";
  // FACEBOOK_URL = environment.API_URL + "auth/seller-social-auth-post";
  GOOGLE_CLIENT_ID :any = environment.GOOGLE_CLIENT_ID;
  is_show_otp : any =false
  loginForm = new FormGroup({
    email: new FormControl(''),
    phone: new FormControl(''),
    password: new FormControl(''),
  });
  otpForm = new FormGroup({
    otp : new FormControl('',Validators.required)
  })
  documentClickListener: any;
  errorMessage :any = ''
  currentUserId : any
  otpErrorMessage :any = ''

  constructor(private fb: FormBuilder, private router: Router,private apiService : ApiServiceService,public shared: SharedService,
    private authService: SocialAuthService, private route: ActivatedRoute
  ) {
    // this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token'); 
    
    if(token){
      if(this.shared.isBrowser()) {
        localStorage.setItem(configuration.LOCAL_STORAGE.USER_TOKEN, token);
      }      
      // localStorage.setItem(configuration.LOCAL_STORAGE.USER_TOKEN, token.data.token);
      // localStorage.setItem(configuration.LOCAL_STORAGE.USER_ID, token.data.seller.id);
      // localStorage.setItem(configuration.LOCAL_STORAGE.USER_NAME, token.data.seller.name);
      // localStorage.setItem(configuration.LOCAL_STORAGE.USER_EMAIL, token.data.seller.email);
      window.location.href = '/profile-view';
    }

    console.log("this.fromButtonLogin", this.fromButtonLogin)
    if (this.fromButtonLogin == true) {
      this.isLoginModal = true
      setTimeout(() => {
        $('#loginModal').modal('show');
      });
    }

    this.authService.authState.subscribe(async (user: any) => {
      console.log('user 1: ',user);
    });
    this.authService.authState.subscribe(async (_user: any) => {
      console.log('_user 2: ',_user)
    })
  }



  onModal() {
    this.isLoginModal = true
    // console.log("click")
    setTimeout(() => {
      $('#loginModal').modal('show');
    });
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then(user => {
      console.log('user 3: ',user);
    });
  }
  
  async onlogin_details() {
    this.submit = true;
    console.log(this.loginForm);
    if (this.loginForm.valid) {
      this.submit = false;
      console.log("this.loginForm", this.loginForm.value)
      let json : any = {
        password : this.loginForm.value.password
      }

      if(this.loginForm.value.email){
        json.email = this.loginForm.value.email
      }

      if(this.loginForm.value.phone){
        json.phone = this.loginForm.value.phone
      }
      this.shared.isLoader = true;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.SELLER_LOGIN, json);
      this.shared.isLoader = false;

      if (res && !res.error && res.data) {
        // this.is_show_otp = true
        // this.currentUserId = res.data.user_id

        localStorage.setItem(configuration.LOCAL_STORAGE.USER_TOKEN, res.data.token);
        localStorage.setItem(configuration.LOCAL_STORAGE.USER_ID, res.data.seller.id);
        localStorage.setItem(configuration.LOCAL_STORAGE.USER_NAME, res.data.seller.name);
        localStorage.setItem(configuration.LOCAL_STORAGE.USER_EMAIL, res.data.seller.email);
        
        setTimeout(() => {
          $('#loginModal').modal('hide');
        }, 0);
        if(!this.fromButtonLogin){
          window.location.href = "/create-property";
        }else {
          location.reload();
        }
      } else {
        this.isSubmitError = true
      }
    }
  }

  _onClose() {
    // this.fromButtonLogin = false
    $('#loginModal').modal('hide');
    setTimeout(() => {
      this.onClose.emit();
    })
  }

  // async signInWithFB(): Promise<void> {
  //   console.log('signInWithFB here....')
  //   this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  //   this.authService.authState.subscribe(async (practitioner: any) => {
  //     console.log(practitioner)
  //   })
  // }

  onBack(){
    this.is_show_otp = false
  }

  async onOtp() {
    let json : any = {
      user_id : this.currentUserId,
      isLogin : true
    };
    if(this.loginForm.value.email){
      json.email = this.loginForm.value.email
      json.otp_email = this.otpForm.value.otp
    }
    if(this.loginForm.value.phone){
      json.phone = this.loginForm.value.phone
      json.otp_phone = this.otpForm.value.otp
    }
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.SELLER_OTP_VERIFICATION, json);
    if (res && !res.error && res.data) {
      localStorage.setItem(configuration.LOCAL_STORAGE.USER_TOKEN, res.data.token);
      localStorage.setItem(configuration.LOCAL_STORAGE.USER_ID, res.data.seller.id);
      localStorage.setItem(configuration.LOCAL_STORAGE.USER_NAME, res.data.seller.name);
      localStorage.setItem(configuration.LOCAL_STORAGE.USER_EMAIL, res.data.seller.email);
      localStorage.setItem(configuration.LOCAL_STORAGE.USER_PHONE, res.data.seller.phone);
      localStorage.setItem(configuration.LOCAL_STORAGE.USER_TYPE, res.data.seller.user_type);
      setTimeout(() => {
        $('#loginModal').modal('hide');
      }, 0);
      if (!this.fromButtonLogin) {
        window.location.href = "/create-property";
      } else {
        location.reload();
      }
    }else{
      this.otpErrorMessage = res.message
    }
  }
}
